import { render, staticRenderFns } from "./scenario.component.html?vue&type=template&id=06b45b0b&scoped=true&"
import script from "./scenario.component.ts?vue&type=script&lang=ts&"
export * from "./scenario.component.ts?vue&type=script&lang=ts&"
import style0 from "./scenario.component.scss?vue&type=style&index=0&id=06b45b0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b45b0b",
  null
  
)

export default component.exports